<template>
  <div class="fullHeigthPage">
    <PageHeader :title="title" :items="items" />
    <!-- HEADER -->
    <div class="row">
      <div class="col-md-4">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <div class="text-center" v-if="loading">
                  <b-spinner class="ms-2" variant="primary"></b-spinner>
                </div>
                <div
                  class="mb-4 d-flex justify-content-center avatar-group"
                  v-if="!loading"
                >
                  <div>
                    <img
                      class="rounded-circle header-profile avatar-xl"
                      :src="fotoPerfil"
                      alt="Header Avatar"
                    />
                    <div class="avatar-sm edit-img">
                      <label
                        for="file-upload"
                        class="avatar-title rounded-circle bg-primary"
                        style="cursor: pointer"
                      >
                        <i
                          class="mdi mdi-pencil font-size-16 align-middle me-1"
                        ></i>
                      </label>
                      <input
                        id="file-upload"
                        type="file"
                        @change="editarFoto"
                        accept=".png,.jpg,.jpeg,.PNG,.JPG,.JPEG"
                      />
                    </div>
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="font-size-15 mb-1">
                    <strong>Nome: </strong>
                    {{ nmRazao }}
                    <small>[{{ cdPessoa }}]</small>
                  </span>
                  <span class="font-size-15 mb-1">
                    <strong>Formação Profissional: </strong>
                    {{ formacaoProfissional }}
                  </span>
                  <span class="font-size-15 mb-1"
                    ><strong>E-mail: </strong>{{ dsemail }}</span
                  >
                  <span class="font-size-15 mb-1"
                    ><strong>Telefone: </strong>{{ dsTelefone }}</span
                  >
                  <span class="font-size-15 mb-1"
                    ><strong>Idade: </strong>{{ dsIdade }}</span
                  >
                </div>
                <div class="mt-1 d-flex justify-content-center">
                  <b-button
                    class="mt-1 me-1"
                    @click="gerarCV"
                    :disabled="requisito.PROGRESSO == 100 ? false : true"
                  >
                    <i class="mdi mdi-fax"></i>
                    Gerar Currículo
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card" v-if="requisito.PROGRESSO">
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <h4 class="fs-bold">Requisitos obrigatórios</h4>
                <b-progress :max="100" class="mb-4" height="1rem">
                  <b-progress-bar
                    :value="requisito.PROGRESSO"
                    class="fw-bold text-dark"
                    :variant="corDaPorcentagemRequisito(requisito.PROGRESSO)"
                    animated
                  >
                    {{ requisito.PROGRESSO }}%
                  </b-progress-bar>
                </b-progress>
                <div v-if="requisito.PROGRESSO < 100">
                  <h4 class="fs-bold">O que falta incluir?</h4>
                  <div>
                    <p
                      v-for="requisitoSugestao in requisitoSugestao"
                      :key="requisitoSugestao"
                    >
                      *{{ requisitoSugestao }}*
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div
              class="row"
              v-if="
                requisito.PROGRESSO == 100 && (tpProfile > 1 || tpProfile < 5)
              "
            >
              <div class="col-md-12">
                <h5 class="fs-bold">
                  Parabéns, você concluiu o cadastro dos dados obrigatórios.
                </h5>
                <p>
                  Falta pouco para concluir o processo de cadastro e filiação!
                </p>
                <p>
                  Acesse
                  <router-link :to="'/perfilPessoal/gestaoDocumentos'"
                    >Gestão de Documentos</router-link
                  >
                  e faça a inclusão para finalizar o processo.
                </p>
              </div>
            </div> -->
            <div
              class="row"
              v-if="
                requisito.PROGRESSO == 100 && (tpProfile > 1 || tpProfile < 5)
              "
            >
              <div class="col-md-12">
                <h5 class="fs-bold">Você está com o cadastro completo.</h5>
                <p v-if="requisito.VAPOSSUIDOCUMENTOPENDENTE > 0">
                  Acesse
                  <router-link :to="'/perfilPessoal/gestaoDocumentos'"
                    >Gestão de Documentos</router-link
                  >
                  para gerenciar a sua documentação.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="card" v-if="perfil.PROGRESSO">
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <h4 class="fs-bold">{{ perfilMenssagem }}</h4>
                <b-progress :max="100" class="mb-4" height="1rem">
                  <b-progress-bar
                    :value="perfil.PROGRESSO"
                    class="fw-bold text-dark"
                    :variant="corDaPorcentagemPerfil(perfil.PROGRESSO)"
                    animated
                  >
                    {{ perfil.PROGRESSO }}%
                  </b-progress-bar>
                </b-progress>
                <div v-if="perfil.PROGRESSO < 100">
                  <h4 class="fs-bold">Sugestões</h4>
                  <div>
                    <p
                      v-for="perfilSugestao in perfilSugestao"
                      :key="perfilSugestao"
                    >
                      *{{ perfilSugestao }}*
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="card" v-if="redesByTyPes.length > 0">
          <div class="card-body">
            <div class="row">
              <div class="col-md-12 d-flex">
                <div class="">
                  <h4 class="fs-bold">Minhas redes sociais</h4>
                  <div class="display-flex">
                    <a
                      v-for="rede in redesByTyPes"
                      :key="rede.SQREDESOCIAL"
                      :href="rede.DSURL"
                      target="_blank"
                    >
                      <i class="mdi mdi-linkedin" style="font-size: 37px"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>

      <div class="col-md-8">
        <div class="row" v-if="tabs">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-body">
                <b-tabs
                  pills
                  justified
                  content-class="p-3 text-muted"
                  v-model="tabIndex"
                  :no-nav-click="true"
                >
                  <b-tab
                    active
                    title-item-class="mb-2"
                    @click="tratarTabs('dadosPessoais')"
                  >
                    <template #title>
                      <i class="mdi mdi-account"></i>
                      <span>
                        Dados Pessoais
                      </span>
                    </template>
                    <div class="row">
                      <DadosPessoais
                        v-if="
                          activeTab == 'dadosPessoais' ||
                            historyTab.find(el => el == 'dadosPessoais')
                        "
                        v-on:navegar="navegar"
                        v-on:carregarNivelPerfil="carregarNivelPerfil"
                        v-on:recebeDadosPessoais="recebeDados"
                      />
                    </div>
                  </b-tab>

                  <b-tab
                    title-item-class="mb-2"
                    @click="tratarTabs('PCD')"
                    v-if="possuiAbasComplementares"
                  >
                    <template #title>
                      <i class="mdi mdi-human-wheelchair"></i>
                      <span> PCD </span>
                    </template>
                    <div class="row">
                      <PCD
                        v-if="
                          activeTab == 'PCD' ||
                            historyTab.find(el => el == 'PCD')
                        "
                        v-on:navegar="navegar"
                        v-on:carregarNivelPerfil="carregarNivelPerfil"
                      />
                    </div>
                  </b-tab>

                  <!-- <b-tab
                    title-item-class="mb-2"
                    @click="tratarTabs('redesSociais')"
                  >
                    <template #title>
                      <i class="mdi mdi-account-star"></i>
                      <span v-if="activeTab === 'redesSociais'">
                        Redes Sociais
                      </span>
                    </template>
                    <div class="row">
                      <RedesSociais
                        v-if="
                          activeTab == 'redesSociais' ||
                          historyTab.find((el) => el == 'redesSociais')
                        "
                        v-on:navegar="navegar"
                        v-on:carregarNivelPerfil="carregarNivelPerfil"
                        v-bind:allTabs="allTabs"
                      />
                    </div>
                  </b-tab> -->

                  <b-tab
                    title-item-class="mb-2"
                    @click="tratarTabs('dadosAcademicos')"
                  >
                    <template #title>
                      <i class="mdi mdi-school"></i>
                      <span>
                        Dados Acadêmicos
                      </span>
                    </template>
                    <DadosAcademicos
                      v-if="
                        activeTab == 'dadosAcademicos' ||
                          historyTab.find(el => el == 'dadosAcademicos')
                      "
                      v-on:navegar="navegar"
                      v-on:carregarNivelPerfil="carregarNivelPerfil"
                    />
                  </b-tab>

                  <!-- <b-tab
                    title-item-class="mb-2"
                    @click="tratarTabs('ExpProfissional')"
                  >
                    <template #title>
                      <i class="mdi mdi-briefcase"></i>
                      <span v-if="activeTab === 'ExpProfissional'">
                        Experiências Profissionais
                      </span>
                    </template>
                    <p>
                      Essas informações irão compor o seu currículo interno,
                      portanto coloque informações que contribua para escolha no
                      processo de vagas.
                    </p>
                    <ExperienciaProfissional
                      v-if="
                        activeTab == 'ExpProfissional' ||
                        historyTab.find((el) => el == 'ExpProfissional')
                      "
                      v-on:navegar="navegar"
                      v-on:carregarNivelPerfil="carregarNivelPerfil"
                    />
                  </b-tab> -->

                  <b-tab
                    title-item-class="mb-2"
                    @click="tratarTabs('areaInteresse')"
                    v-if="possuiAbasComplementares"
                  >
                    <template #title>
                      <i class="mdi mdi-view-list-outline"></i>
                      <span>
                        Áreas de interesse
                      </span>
                    </template>
                    <AreasInteresse
                      v-if="activeTab == 'areaInteresse'"
                      v-on:navegar="navegar"
                      v-on:carregarNivelPerfil="carregarNivelPerfil"
                    />
                  </b-tab>

                  <!-- <b-tab title-item-class="mb-2" @click="tratarTabs('idiomas')">
                    <template #title>
                      <i class="mdi mdi-web"></i>
                      <span v-if="activeTab === 'idiomas'"> Idiomas </span>
                    </template>
                    <p>
                      Essas informações irão compor o seu currículo interno,
                      portanto coloque informações que contribua para escolha no
                      processo de vagas.
                    </p>
                    <idiomas
                      v-if="
                        activeTab == 'idiomas' ||
                        historyTab.find((el) => el == 'idiomas')
                      "
                      v-on:navegar="navegar"
                      v-on:carregarNivelPerfil="carregarNivelPerfil"
                    />
                  </b-tab> -->

                  <b-tab
                    title-item-class="mb-2"
                    @click="tratarTabs('enderecos')"
                  >
                    <template #title>
                      <i class="mdi mdi-home"></i>
                      <span> Endereços </span>
                    </template>
                    <Enderecos
                      v-if="
                        activeTab == 'enderecos' ||
                          historyTab.find(el => el == 'enderecos')
                      "
                      v-on:navegar="navegar"
                      v-on:carregarNivelPerfil="carregarNivelPerfil"
                    />
                  </b-tab>

                  <b-tab
                    title-item-class="mb-2"
                    @click="tratarTabs('contatos')"
                  >
                    <template #title>
                      <i class="mdi mdi-card-account-phone"></i>
                      <span> Contatos </span>
                    </template>
                    <Contatos
                      v-if="
                        activeTab == 'contatos' ||
                          historyTab.find(el => el == 'contatos')
                      "
                      v-on:navegar="navegar"
                      v-on:carregarNivelPerfil="carregarNivelPerfil"
                    />
                  </b-tab>

                  <b-tab title-item-class="mb-2" @click="tratarTabs('email')">
                    <template #title>
                      <i class="mdi mdi-email"></i>
                      <span> Email </span>
                    </template>
                    <Email
                      v-if="
                        activeTab === 'email' ||
                          historyTab.find(el => el === 'email')
                      "
                      v-on:navegar="navegar"
                      v-on:carregarNivelPerfil="carregarNivelPerfil"
                    />
                  </b-tab>

                  <b-tab
                    v-if="possuiAbasComplementares"
                    title-item-class="mb-2"
                    @click="tratarTabs('infoBancarias')"
                  >
                    <template #title>
                      <i class="mdi mdi-bank"></i>
                      <span>
                        Informações Bancárias
                      </span>
                    </template>
                    <InformacoesBancarias
                      v-if="
                        activeTab === 'infoBancarias' ||
                          historyTab.find(el => el === 'infoBancarias')
                      "
                      v-on:navegar="navegar"
                      v-on:carregarNivelPerfil="carregarNivelPerfil"
                    />
                  </b-tab>
                </b-tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/page-header";
import DadosPessoais from "@/components/cadastroPessoalErp/dadosPessoais";
import DadosAcademicos from "@/components/cadastroPessoalErp/dadosAcademicos";
// import ExperienciaProfissional from "@/components/cadastroPessoalErp/experienciaProfissional";
import AreasInteresse from "@/components/cadastroPessoalErp/areasInteresse";
// import Idiomas from "@/components/cadastroPessoalErp/idiomas";
import Enderecos from "@/components/cadastroPessoalErp/enderecos";
import Contatos from "@/components/cadastroPessoalErp/contatos";
import PCD from "@/components/cadastroPessoalErp/pcd";
// import RedesSociais from "@/components/cadastroPessoalErp/redesSociais.vue";
import InformacoesBancarias from "@/components/cadastroPessoalErp/informacoesBancarias.vue";
import Email from "@/components/cadastroPessoalErp/email.vue";

export default {
  components: {
    PageHeader,
    DadosPessoais,
    DadosAcademicos,
    // ExperienciaProfissional,
    AreasInteresse,
    // Idiomas,
    Enderecos,
    Contatos,
    PCD,
    // RedesSociais,
    InformacoesBancarias,
    Email
  },

  data() {
    return {
      title: "Cadastro Pessoal",
      fotoPerfil: require("@/assets/images/user.png"),
      nmRazao: "",
      cdPessoa: "",
      sqUsuario: "",
      items: [
        {
          text: ""
        }
      ],
      tabIndex: 1,
      loading: true,
      dsemail: "",
      viewCooperado: true,
      tabs: true,
      arquivo: {
        externsaoArquivo: "",
        arquivo: ""
      },
      dsIdade: "",
      dsTelefone: "",
      formacaoProfissional: "",
      perfil: {},
      perfilMenssagem: "",
      perfilSugestao: [],
      requisito: {},
      requisitoMenssagem: "",
      requisitoSugestao: [],
      tpProfile: "",
      activeTab: "dadosPessoais",
      historyTab: ["dadosPessoais"],
      allTabs: ["dadosPessoais"],
      possuiAbasComplementares: false
    };
  },

  created() {
    this.$tools.fecharMenu();
    this.carregarNivelPerfil();
  },

  methods: {
    navegar(nomeDaAba, direcao) {
      this.activeTab = nomeDaAba;
      this.historyTab.push(nomeDaAba);
      this.allTabs.push(nomeDaAba);
      if (direcao) {
        this.tabIndex++;
      } else {
        this.tabIndex--;
      }
    },

    tratarTabs(tab) {
      this.activeTab = tab;
      this.historyTab.push(tab);
    },

    possuiAcessoAbasComplementares(authMe, perfil) {
      const perfis = authMe?.tp_Pessoa?.sq_cargo
        || this.$store.state.me?.tp_Pessoa?.sq_cargo
        || [];

      const niveis = [
        ...(Array.isArray(perfis) ? perfis : [perfis]),
        perfil?.PessoaNivel?.Descricao,
        perfil?.pessoaNivel?.descricao,
        perfil?.NivelPessoa?.Descricao,
        perfil?.nivelPessoa?.descricao,
      ].filter(Boolean);

      if (niveis.some(nivel => /^(cooperado|candidato permitido)\b/i.test(String(nivel).trim()))) {
        return true;
      }

      // O ProfileResource do ERP informa o candidato permitido pela flag de
      // afiliação. Ela é a fonte utilizada quando o nível ainda não vem
      // descrito no payload de login.
      const permiteFiliacao = perfil?.Afiliacao?.PermiteFiliacao
        ?? perfil?.afiliacao?.permiteFiliacao;
      return ["S", "1", "TRUE"].includes(String(permiteFiliacao || "").trim().toUpperCase());
    },

    async gerarCV() {
      const janelaCurriculo = window.open("", "_blank");
      if (!janelaCurriculo) {
        this.$tools.alerta("Permita a abertura de pop-ups para gerar o currículo.", "warning");
        return;
      }

      try {
        const response = await this.$http.get("api/profileErp/curriculo", {
          headers: {
            Authorization: `Bearer ${this.$store.state.access_token}`,
            Accept: "text/html",
          },
          responseType: "text",
        });
        const urlCurriculo = URL.createObjectURL(
          new Blob([response.data], { type: "text/html;charset=utf-8" })
        );

        janelaCurriculo.location.replace(urlCurriculo);
        setTimeout(() => URL.revokeObjectURL(urlCurriculo), 60000);
      } catch (err) {
        janelaCurriculo.close();
        this.$tools.alerta(
          err.response?.data?.message || "Não foi possível gerar o currículo no ERP.",
          "error"
        );
      }
    },

    async carregarNivelPerfil() {
      try {
        const response = await this.$http.get("api/profileErp/requisitos");
        const estatisticas = response.data?.Estatisticas || response.data?.estatisticas || {};

        const progObrigatorios = estatisticas.PorcentagemObrigatorios !== undefined
          ? estatisticas.PorcentagemObrigatorios
          : (response.data.percentualRequisitosObrigatorios !== undefined
            ? response.data.percentualRequisitosObrigatorios
            : (response.data.progresso !== undefined ? response.data.progresso : 0));

        const progGeral = estatisticas.PorcentagemGeral !== undefined
          ? estatisticas.PorcentagemGeral
          : (response.data.percentualCompletude !== undefined
            ? response.data.percentualCompletude
            : (response.data.progresso !== undefined ? response.data.progresso : 0));

        this.requisito = {
          PROGRESSO: Number(progObrigatorios),
          MENSAGEM: response.data.mensagem || "",
          VAPOSSUIDOCUMENTOPENDENTE: response.data.possuiDocumentoPendente ? 1 : 0
        };

        if (this.requisito.PROGRESSO < 100) {
          this.requisitoSugestao = (response.data.requisitosPendentes || [])
            .map(r => r.descricao || r)
            .filter(item => item !== "");
        }

        this.perfil = {
          PROGRESSO: Number(progGeral),
          MENSAGEM: response.data.mensagem || ""
        };

        if (this.perfil.PROGRESSO < 100) {
          this.perfilSugestao = (response.data.sugestoes || [])
            .map(s => s.descricao || s)
            .filter(item => item !== "");
        }

        this.tpProfile = this.$store.state.me?.tp_Pessoa?.cd_tp_pessoa || 2;
      } catch (error) {
        console.error(error);
      }
    },

    async recebeDados(item) {
      this.nmRazao = item.authMe.nm_razao;
      this.cdPessoa = item.authMe.cd_pessoa;
      this.sqUsuario = item.authMe.sq_usuario;

      this.formacaoProfissional = item.registroProfissional?.NMPROFISSAO
        ? item.registroProfissional.NMPROFISSAO
        : null;

      this.dsemail = item.authMe.ds_email;

      // Calcula a idade
      if (item.dadosPessoais?.DT_NASC) {
        this.dsIdade =
          this.$tools.calcularIdade(item.dadosPessoais.DT_NASC) + " Anos";
      } else {
        this.dsIdade = "";
      }
      if (
        item.authMe.contato &&
        (item.authMe.contato.nr_telefone || item.authMe.contato.nr_ddd)
      ) {
        let ddd = item.authMe.contato.nr_ddd || "";
        let tel = item.authMe.contato.nr_telefone || "";

        if (tel.includes("@")) {
          this.dsTelefone = "";
        } else {
          if (!ddd && tel) {
            const digits = tel.replace(/\D/g, "");
            if (digits.length === 10 || digits.length === 11) {
              ddd = digits.substring(0, 2);
              tel = digits.substring(2);
            }
          }
          if (ddd && tel) {
            this.dsTelefone = "(" + ddd + ") " + tel;
          } else {
            this.dsTelefone = tel || ddd || "";
          }
        }
      } else {
        this.dsTelefone = "";
      }

      if (!this.dsTelefone) {
        this.$http
          .get("api/profileErp/contatos")
          .then(res => {
            const list = res.data || [];
            const tel = list.find(c => {
              if (c.TipoContato && c.TipoContato.TipoComunicacao === "E")
                return false;
              if (c.Descricao && c.Descricao.includes("@")) return false;
              return true;
            });
            if (tel && tel.Descricao) {
              let ddd = tel.nr_ddd || tel.ddd || tel.Ddd || "";
              let num =
                tel.nr_telefone ||
                tel.telefone ||
                tel.Telefone ||
                tel.Descricao ||
                "";
              const digits = num.replace(/\D/g, "");
              if (!ddd && (digits.length === 10 || digits.length === 11)) {
                ddd = digits.substring(0, 2);
                num = digits.substring(2);
              }
              if (ddd && num) {
                this.dsTelefone = "(" + ddd + ") " + num;
              } else {
                this.dsTelefone = num || ddd || "";
              }
            }
          })
          .catch(() => {});
      }

      // Coloca foto do perfil
      let foto = item.authMe?.foto || item.authMe?.Foto || item.authMe?.Pessoa?.Foto || item.authMe?.Usuario?.Pessoa?.Foto;
      if (foto) {
        // Adiciona timestamp para evitar que o browser use uma foto em cache (especialmente após troca)
        const fotoTs = foto.includes("?") ? foto : foto + `?t=${Date.now()}`;
        if (foto.startsWith("http://") || foto.startsWith("https://") || foto.startsWith("data:image")) {
          this.fotoPerfil = fotoTs;
        } else {
          this.fotoPerfil = this.$caminhoFotoPerfil + fotoTs;
        }
      } else {
        this.fotoPerfil = require("@/assets/images/user.png");
      }

      this.possuiAbasComplementares = this.possuiAcessoAbasComplementares(
        item.authMe,
        item.perfil
      );
      this.loading = false;
    },

    editarFoto(event) {
      this.loading = true;
      const file = event.target.files || event.dataTransfer.files;
      if (!file || !file.length) {
        this.loading = false;
        return;
      }
      const extension = file[0].name.substring(file[0].name.lastIndexOf(".") + 1);
      const extPermitidas = "png jpg jpeg PNG JPG JPEG";
      if (!extPermitidas.includes(extension)) {
        this.$tools.alerta("Extensão inválida", "error");
        this.loading = false;
        return;
      }

      const formData = new FormData();
      formData.append("arquivo", file[0]);
      formData.append("foto", file[0]);
      formData.append("Foto", file[0]);

      this.$http
        .post("api/profileErp/foto", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(() => {
          this.$tools.alerta("Foto de perfil atualizada com sucesso", "success");

          // A URL da foto no portal_api é baseada no ID do usuário (pessoa),
          // não no ID do arquivo — portanto a mesma URL já existente continua válida
          // e aponta para a foto atual. Basta forçar o browser a recarregar
          // adicionando um timestamp para bustar o cache local do browser.
          const urlBase = this.fotoPerfil.split("?")[0];
          const fotoAtualizada = `${urlBase}?t=${Date.now()}`;
          this.fotoPerfil = fotoAtualizada;
          this.$root.$emit("atualizarFotoPerfil", fotoAtualizada);
        })
        .catch((err) => {
          this.$tools.alerta(err.response?.data?.message || "Erro ao atualizar a foto de perfil", "error");
        })
        .finally(() => {
          this.loading = false;
          this.carregarNivelPerfil();
        });
    },


    corDaPorcentagemRequisito(valor) {
      if (valor <= 30) {
        return "danger";
      }
      if (valor <= 70) {
        return "warning";
      }
      if (valor <= 99) {
        return "primary";
      }
      if (valor === 100) {
        return "success";
      }
    },

    corDaPorcentagemPerfil(valor) {
      if (valor <= 30) {
        this.perfilMenssagem = "Qualidade do perfil: Nível básico!";
        return "danger";
      }
      if (valor <= 70) {
        this.perfilMenssagem = "Qualidade do perfil: Nível intermediário!";
        return "warning";
      }
      if (valor <= 99) {
        this.perfilMenssagem = "Qualidade do perfil: Nível avançado";
        return "primary";
      }
      if (valor == 100) {
        this.perfilMenssagem = "Perfil completo!";
        return "success";
      }
    }
  }
};
</script>
<style scoped>
.edit-img {
  position: absolute;
  top: 25%;
  margin-left: 17%;
}
.avatar-group {
  border: 0px solid #fff !important;
}
input[type="file"] {
  display: none;
}
</style>
